import { combineReducers, configureStore } from "@reduxjs/toolkit";
import calenderSlice from "./slices/calender/calenderSlice";
import metaSearchSlice from "./slices/metaSearch/metaSearch";
import accountSlice from "./slices/account/accountSlice";
import searchAdsSlice from "./slices/searchAds/searchAds";
import sidebarSlice from "./slices/sidebar/sidebar";
import editBidSlice from "./slices/editBid/editBid";
import pMaxSlice from "./slices/pMax/pMax";
import displayAdsSlice from "./slices/displayAds/displayAds";
import aiConnectSlice from "./slices/aiConnect/aiConnect";
import metaTravelAdsSlice from "./slices/metaTravelAds/metaTravelAds";

const reducers = combineReducers({
  calender: calenderSlice,
  metaSearch: metaSearchSlice,
  account: accountSlice,
  searchAds: searchAdsSlice,
  sidebar: sidebarSlice,
  editBid: editBidSlice,
  pMax: pMaxSlice,
  displayAds: displayAdsSlice,
  aiConnect: aiConnectSlice,
  metaTravelAds: metaTravelAdsSlice,
});
export const store = configureStore({
  reducer: reducers,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});
